import { recordVisit } from './src/utils/signupAttribution';
import { loadLanguage } from './src/i18n/config';

export { wrapPageElement, wrapRootElement } from './src/wrapElements';

// The page's translations are a separate chunk; hydrating before it arrives would render
// translation keys and mismatch the server HTML. <html lang> is set from the page's language.
export const replaceHydrateFunction = () => (element, container) => {
  const { hydrateRoot, createRoot } = require('react-dom/client');
  const focusEl = document.getElementById('gatsby-focus-wrapper');
  loadLanguage(document.documentElement.lang).then(() => {
    if (focusEl && focusEl.children.length) hydrateRoot(container, element);
    else createRoot(container).render(element);
  });
};

// Runs on the first page load and on every client-side navigation. There is no logged-in
// check: a sign-in here redirects straight to bloomstories.com, and importing Firebase
// for it would load the auth SDK and Google's sign-in iframe on every page.
export const onRouteUpdate = () => {
  recordVisit();
};
